import { useEffect }                            from 'react';
import Select                                   from 'react-select';
import { Dialog, DialogBackdrop, DialogPanel }  from '@headlessui/react';
import { useForm, Controller }                  from "react-hook-form";
import '../../styles/LoadingTable.css'

function JustificationForm ({
        isOpen, 
        onClose, 
        categories, 
        changeCategory, 
        selectedCategories, 
        onSubmit,
        initialValues,
        isEditMode,
        loading,
        comparisionNumber
    }) {

    const { 

        control, 
        register,
        handleSubmit,
        reset,
        formState: { errors },
        setValue

    } = useForm();

    useEffect(() => {
        if (!isOpen) {
            reset({
                select1: null,
                select2: null,
                select3: null,
                select4: null,
                select5: null,
                wagons: "",
                description: ""
            });
        }
    }, [isOpen, reset]);


    useEffect(() => {
        
        if (initialValues) {

            setValue("wagons", initialValues.wagons)
            setValue("description", initialValues.description)

        }
        
    }, [initialValues, setValue]);

    return (

        <Dialog open={isOpen} onClose={onClose} className="relative z-[100]">

        <DialogBackdrop transition className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"/>
        
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                
                <DialogPanel transition className="w-[1010px] relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95">   
                    
                    <div className="app-container">
                        
                        <header className="bg-azul-profundo-m flex justify-between items-center pl-4 pr-1 py-3">
                            
                            <h2 className="text-white text-[1rem] leading-7 font-semibold">
                                {isEditMode ? "Editar" : "Nova"} Justificativa
                            </h2>  
                            
                            <button onClick={onClose} className="text-[1.2rem] text-white hover:text-gray-200 pr-2 ">×</button>
                            
                        </header>

                        {/* Inputs */}
                        <div className="px-4 pb-4 pt-5 sm:p-6 sm:pb-4 flex flex-col gap-[10px]">
                            
                            <div className='flex flex-row gap-[8px]'>
                                
                                {/* Select 1 */}
                                <div className="flex flex-col w-full gap-[3px]">
                                    <span className="text-sm font-semibold">Categoria 1:</span>
                                    <> {loading ? (

                                        <div className='one h-[38px] border-[solid] border-[1px] border-[#e5e5e5] rounded-[6px]'></div>
                                        
                                    ) : (
                                        <Controller
                                            control={control}
                                            name="select1"
                                            rules={{ required: false }}
                                            render={({ field }) => (
                                                <Select
                                                    options={categories[0]}
                                                    classNamePrefix="select"
                                                    defaultValue={null}
                                                    isSearchable={false}
                                                    onChange={(selectedOption) => {changeCategory(selectedOption, 0)}}
                                                    value={selectedCategories[0]}
                                                />
                                            )}
                                        />
                                    )}
                                    
                                    </>

                                </div>

                                {/* Select 2 */}
                                <div className="flex flex-col w-full gap-[3px]">
                                    <span className="text-sm font-semibold">Categoria 2:</span>

                                    <>{loading ? (

                                        <div className='one h-[38px] border-[solid] border-[1px] border-[#e5e5e5] rounded-[6px]'></div>

                                    ) : (

                                        <Controller
                                            control={control}
                                            name="select2"
                                            rules={{ required: false }}
                                            render={({ field }) => (
                                                <Select
                                                    isClearable={true}
                                                    options={categories[1]}
                                                    classNamePrefix="select"
                                                    defaultValue={categories[1][0]}
                                                    isSearchable={false}
                                                    onChange={(selectedOption) => {changeCategory(selectedOption, 1)}}
                                                    value={selectedCategories[1]}
                                                />
                                            )}
                                        />                                        

                                    )}
                                    
                                    </>
                                </div>

                                {/* Select 3 */}
                                <div className="flex flex-col w-full gap-[3px]">
                                    <span className="text-sm font-semibold">Categoria 3:</span>

                                    <>{loading ? (

                                        <div className='one h-[38px] border-[solid] border-[1px] border-[#e5e5e5] rounded-[6px]'></div>

                                    ) : (

                                        <Controller
                                            control={control}
                                            name="select3"
                                            rules={{ required: false }}
                                            render={({ field }) => (
                                                <Select
                                                    isClearable={true}
                                                    options={categories[2]}
                                                    classNamePrefix="select"
                                                    defaultValue={categories[2][0]}
                                                    isSearchable={false}
                                                    onChange={(selectedOption) => {changeCategory(selectedOption, 2)}}
                                                    value={selectedCategories[2]}
                                                />
                                            )}
                                        />
                                    )}
                                    
                                    </>
                                </div>

                                {/* Select 4 */}
                                <div className="flex flex-col w-full gap-[3px]">
                                    <span className="text-sm font-semibold">Categoria 4:</span>

                                    <>{loading ? (

                                        <div className=' one h-[38px] border-[solid] border-[1px] border-[#e5e5e5] rounded-[6px]'></div>

                                    ) : (

                                        <Controller
                                            control={control}
                                            name="select4"
                                            rules={{ required: false }}
                                            render={({ field }) => (
                                                <Select
                                                    isClearable={true}
                                                    options={categories[3]}
                                                    classNamePrefix="select"
                                                    defaultValue={categories[3][0]}
                                                    isSearchable={false}
                                                    onChange={(selectedOption) => {changeCategory(selectedOption, 3)}}
                                                    value={selectedCategories[3]}
                                                />
                                            )}
                                        />
                                    )}
                                    
                                    </>
                                </div>
                            
                            {/* Select 5 */}
                            <div className="flex flex-col w-full gap-[3px]">
                                    <span className="text-sm font-semibold">Categoria 5:</span>

                                    <>{loading ? (

                                        <div className='one h-[38px] border-[solid] border-[1px] border-[#e5e5e5] rounded-[6px]'></div>

                                    ) : (

                                        <Controller
                                            control={control}
                                            name="select5"
                                            rules={{ required: false }}
                                            render={({ field }) => (
                                                <Select
                                                    isClearable={true}
                                                    options={categories[4]}
                                                    classNamePrefix="select"
                                                    defaultValue={categories[4][0]}
                                                    isSearchable={false}
                                                    onChange={(selectedOption) => {changeCategory(selectedOption, 4)}}
                                                    value={selectedCategories[4]}
                                                />
                                            )}
                                        />

                                    )}
                                    

                                    </>
                            </div>

                            </div>

                            {/* Wagons */}    
                            <div className="flex flex-col w-full gap-[3px]">
                                <span className="text-sm font-semibold">Quantidade de Vagões:</span>
                                <input 
                                    type="text" 
                                    {...register("wagons", { required: false })}
                                    className="border border-gray-300 rounded-[3px] px-3 py-2 focus:outline-none focus:border-blue-500"
                                />
                            </div>

                            {/* Description */}            
                            <div className="flex flex-col gap-[3px]">
                                <span className="text-sm font-semibold">Descrição:</span>      
                                <textarea 
                                    id="multiLineInput" 
                                    rows="5" 
                                    className="border border-gray-300 rounded-[3px] px-3 py-2 focus:outline-none focus:border-blue-500 blue-scrollbar" 
                                    placeholder="Escreva aqui..." 
                                    {...register("description", { required: false })}
                                ></textarea>
                            </div>

                        <div className="w-full bg-neutro borda-cinza rounded-[7px] px-[1rem] py-[0.5rem]">
                            <span className="text-sm">Vagões justificados: {comparisionNumber}</span>
                        </div>
                        </div>
                        
                                
                        {/* Buttons */}
                        <div className="w-full bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                            
                            <button 
                                type="submit" 
                                className="btn btn-azul-prof sm:ml-3 w-[50%] text-[1.125rem]"
                                onClick={handleSubmit(onSubmit)}
                            >
                                Salvar
                            </button>

                            <button 
                                type="button" 
                                onClick={onClose} 
                                className="btn btn-cinza w-[50%] text-[1.125rem]"
                            >
                                Cancelar
                            </button>

                        </div>
                        
                    </div>
                </DialogPanel>
            </div>

        </div>
        
        </Dialog>
    );
}
export default JustificationForm